import React from "react";
import "./EmailStyle.scss";
import { emailTextContent } from "./constant/index";

const EmailSection = () => {
  return (
    <section className="email-section">
      <div className="email-wrap">
        <div className="email-box">
          <div className="btn-box">
            <a href={emailTextContent.email} className="email-btn">{emailTextContent.btnText}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmailSection;
